import React from 'react';
import { toast } from 'react-toastify';
import { Translate } from 'react-localize-redux';
import axios from 'axios';

import { CMS_CHECK_MULTI_ROUND_REMOVE, FETCH_APPLICATION_COLLECTION } from '../network/api';
import { CONFIG } from '../../config';
import { ALERT_TYPE } from './constant';


export const hlog = anyObj => {
  if (CONFIG.DEV) {
    /* eslint no-console: 'off' */
    // custom console
    console.log(anyObj);
  }
};

// Alert Notifications

export const HHAlert = (translation, type = ALERT_TYPE.INFO, customConfig) => {
  const { id, context } = translation;
  const emptyCallback = () => {};
  const defaultConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000,
    onClose: emptyCallback
  };
  const config = {
    ...defaultConfig,
    ...customConfig
  };
  const messageComp = (
    <Translate>
      {({ translate }) => (
        <section>
          <h1 className='Toastify__header'>{translate(`common.${type}`)}</h1>
          <p>{translate(id, context)}</p>
        </section>
      )}
    </Translate>
  );
  toast[type](messageComp, config);
};

// screening pending validate
// validate if screening pending list is empty b4 admin turn off screening
export const msScreeningValidate = async (data, token, previousScreeningStatus) => {
  // screening was on and is set to off now
  if (!data.isScreening && previousScreeningStatus) {
    try {
      const res = await axios
        .post(FETCH_APPLICATION_COLLECTION, {
          key: 'OAoZIzAlFjPD6o3BAxNtdVfG5JPugwDB',
          eventSlug: data.slug,
          token
        });
      if (res.data && res.data.profileList && res.data.profileList.length > 0) {
        HHAlert({ id: 'alert.error.screeningPendingListNotEmpty' }, ALERT_TYPE.ERROR);
        return false;
      }
    } catch (err) {
      HHAlert({ id: 'alert.error.screeningPendingListNotEmpty' }, ALERT_TYPE.ERROR);
      return false;
    }
  } return true;
};

// validate multi round submission deadline for event create
export const multiRoundDeadlineValidateCreate = (data) => {
  if (data.rounds && data.rounds > 1) {
    for (let i = 1; i < data.rounds + 1; i += 1) {
      if (data[`round${i}Deadline`]) {
        if (i === 1 && !data[`round${i}Deadline`].isBetween(data.start, data[`round${2}Deadline`])) {
          HHAlert({ id: 'alert.error.multiRoundDeadlineFormat' }, ALERT_TYPE.ERROR);
          return false;
        } else if (i === data.rounds && !data[`round${i}Deadline`].isBetween(data[`round${i - 1}Deadline`], data.end)) {
          HHAlert({ id: 'alert.error.multiRoundDeadlineFormat' }, ALERT_TYPE.ERROR);
          return false;
        } else if (
          data.rounds > 2 &&
           i !== 1 &&
           i !== data.rounds &&
           !data[`round${i}Deadline`].isBetween(data[`round${i - 1}Deadline`], data[`round${i + 1}Deadline`])) {
          HHAlert({ id: 'alert.error.multiRoundDeadlineFormat' }, ALERT_TYPE.ERROR);
          return false;
        }
      } else {
        HHAlert({ id: 'alert.error.missRequiredFields' }, ALERT_TYPE.ERROR);
        return false;
      }
    }
  } return true;
};

// multi round validate submission deadline
// validate if teams & submission exits if removing any rounds
export const multiRoundDeadlineValidate = async (data, previousRoundNumber, token) => {
  if (data.rounds && data.rounds > 1) {
    for (let i = 1; i < data.rounds + 1; i += 1) {
      if (data[`round${i}Deadline`]) {
        if (i === 1 && !data[`round${i}Deadline`].isBetween(data.start, data[`round${2}Deadline`])) {
          HHAlert({ id: 'alert.error.multiRoundDeadlineFormat' }, ALERT_TYPE.ERROR);
          return false;
        } else if (i === data.rounds && !data[`round${i}Deadline`].isBetween(data[`round${i - 1}Deadline`], data.end)) {
          HHAlert({ id: 'alert.error.multiRoundDeadlineFormat' }, ALERT_TYPE.ERROR);
          return false;
        } else if (
          data.rounds > 2 &&
           i !== 1 &&
           i !== data.rounds &&
           !data[`round${i}Deadline`].isBetween(data[`round${i - 1}Deadline`], data[`round${i + 1}Deadline`])) {
          HHAlert({ id: 'alert.error.multiRoundDeadlineFormat' }, ALERT_TYPE.ERROR);
          return false;
        }
      } else {
        HHAlert({ id: 'alert.error.missRequiredFields' }, ALERT_TYPE.ERROR);
        return false;
      }
    }
  }
  // if event is previously a signle event then skip
  // check if wanted round number is lower than previous round number(!datarounds means single round event hence round number = 1)
  if (previousRoundNumber && previousRoundNumber > 1) {
    if (!data.rounds || (data.rounds && data.rounds < previousRoundNumber)) {
      // user wants to remove some rounds
      let newRoundNumber;
      if (data.rounds) {
        newRoundNumber = data.rounds;
      } else {
        newRoundNumber = 1;
      }
      try {
        const res = await axios
          .post(CMS_CHECK_MULTI_ROUND_REMOVE, {
            eventSlug: data.slug,
            token,
            newRoundNumber
          });
        const { code } = res;
        if (code !== 200) {
          HHAlert({ id: 'alert.error.teamOrSubExistsWhileRemovingMultiRound' }, ALERT_TYPE.ERROR);
          return false;
        } return true;
      } catch (err) {
        hlog(err);
        return false;
      }
    }
  }
  return true;
};

export const HHEncrypt = plaintext => {
  const key = 'VkRCelBWUXdjejFVTUhNOWhhY2t4d2ViZHhk';
  const e1 = btoa(plaintext);
  const e2 = btoa(`${e1}${e1}${e1}`);
  return btoa(`${e2}${key}`);
};

export const isMobileAgent = () => {
  const agent = navigator.userAgent || navigator.vendor || window.opera;
  return (
    // eslint-disable-next-line
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      agent
    ) ||
    // eslint-disable-next-line
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
      agent.substr(0, 4)
    )
  );
};

// disable React Developer Tools
export const disableReactDevTools = () => {
  const noop = () => undefined;
  /* eslint-disable no-underscore-dangle */
  const DEV_TOOLS = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;

  if (typeof DEV_TOOLS === 'object') {
    for (const [key, value] of (Object).entries(DEV_TOOLS)) {
      DEV_TOOLS[key] = typeof value === 'function' ? noop : null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/common/util.js